import { Box } from '@mui/material';

/**
 * Where a canvas drag would land: a 2px line on the top or bottom edge of the element (or section)
 * under the pointer. Absolutely positioned, never part of the layout.
 */
export function CanvasDropIndicator({ edge }: { edge: 'top' | 'bottom' }) {
  return (
    <Box
      aria-hidden
      data-testid="document-builder:block-canvas:drop-indicator"
      data-edge={edge}
      sx={{
        position: 'absolute',
        left: 0,
        right: 0,
        [edge]: -2,
        height: 3,
        borderRadius: 2,
        bgcolor: 'var(--primary-500, #2563eb)',
        pointerEvents: 'none',
        zIndex: 4
      }}
    />
  );
}
